import { Box, Typography } from "@mui/material";

import styles from "../../../../assets/styles/componentStyles/billingStyles/billingUsage.module.scss";

import { billingSubscriptionFeatureUsage } from "../../../../models/axiosModel";
import { COMPLIMENTARY_AI_CREDITS_FEATURE } from "../../constant.billing";
import UsageOverviewRow from "./usageOverviewRow";

interface usageOverviewProps {
    usageLimitsData?: billingSubscriptionFeatureUsage | null;
}

const USAGE_OVERVIEW_ROWS = ["Resource", "Used / Limit", "Progress"];

const UsageOverview = (props: usageOverviewProps) => {
    
    const { usageLimitsData } = props;

    const features = usageLimitsData?.features?.filter((feature) => (
        feature.billing_feature_name !== COMPLIMENTARY_AI_CREDITS_FEATURE
        && !feature.flag_add_on_limit
    )) || [];

    return (
        <Box className={styles.overviewCard}>

            <Box className={styles.overviewHeader}>
                <Typography className={styles.overviewTitle}>
                  Usage Overview
                </Typography>
            </Box>

            <Box className={styles.overviewTable}>
                <Box className={styles.overviewTableHead}>
                  {USAGE_OVERVIEW_ROWS.map((row) => (
                    <Typography key={row}>
                      {row}
                    </Typography>
                  ))}
                </Box>

                {features.length > 0 ? (
                    features.map((feature) => (
                        <UsageOverviewRow
                            key={feature.billing_feature_id}
                            feature={feature}
                        />
                    ))
                ) : (
                    <Box className={styles.overviewEmpty}>
                        <Typography>
                          No usage data available
                        </Typography>
                    </Box>
                )}
            </Box>

        </Box>
    );
};

export default UsageOverview;
